const dragPayload = ref(null);

export function useSurfaceEditorDragState() {
  function setDragPayload(payload) {
    dragPayload.value = payload;
  }

  function clearDragPayload() {
    dragPayload.value = null;
  }

  return {
    dragPayload,
    setDragPayload,
    clearDragPayload
  };
}
